/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { CriticalElementRevisionDto } from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType } from '../../orval-mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_FD_ANALYST**<br /><br />
 */
export const getCriticalElementRevisions = (
  userId: string,
  clientId: number,
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CriticalElementRevisionDto[]>(
    {
      url: `/api/${userId}/clients/${clientId}/critical-elements/${id}/revisions`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getGetCriticalElementRevisionsQueryKey = (
  userId: string,
  clientId: number,
  id: number
) => {
  return [
    `/api/${userId}/clients/${clientId}/critical-elements/${id}/revisions`,
  ] as const;
};

export const getGetCriticalElementRevisionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCriticalElementRevisions>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCriticalElementRevisions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCriticalElementRevisionsQueryKey(userId, clientId, id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCriticalElementRevisions>>
  > = ({ signal }) =>
    getCriticalElementRevisions(userId, clientId, id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && clientId && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCriticalElementRevisions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCriticalElementRevisionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCriticalElementRevisions>>
>;
export type GetCriticalElementRevisionsQueryError = ErrorType<unknown>;

export function useGetCriticalElementRevisions<
  TData = Awaited<ReturnType<typeof getCriticalElementRevisions>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCriticalElementRevisions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCriticalElementRevisions>>,
          TError,
          Awaited<ReturnType<typeof getCriticalElementRevisions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCriticalElementRevisions<
  TData = Awaited<ReturnType<typeof getCriticalElementRevisions>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCriticalElementRevisions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCriticalElementRevisions>>,
          TError,
          Awaited<ReturnType<typeof getCriticalElementRevisions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCriticalElementRevisions<
  TData = Awaited<ReturnType<typeof getCriticalElementRevisions>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCriticalElementRevisions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetCriticalElementRevisions<
  TData = Awaited<ReturnType<typeof getCriticalElementRevisions>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCriticalElementRevisions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCriticalElementRevisionsQueryOptions(
    userId,
    clientId,
    id,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
